import { FC } from 'react';

import cn from 'classnames';

export interface IErrorType {
  message: string;
  classError?: string;
}

export const ErrorMessage: FC<IErrorType> = (props) => {
  const { message, classError } = props;

  return <span className={cn('error-text', classError)}>{message}</span>;
};
